//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {computed, reactive, ref} from "@nuxtjs/composition-api";
import {validateEmail, markFieldAsTouched, touchedState} from "~/helpers/validation-utils";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
export default {
  name: "CheckoutAsGuest",
  components: {
    SfInput,
    SfLoader
  },
  props: {
    texts: {
      type: Object
    },
    title: {
      type: String
    },
    guestLoginLoader: {
      type: Boolean,
    },
    userEmail: {
      type: String,
      default: () => ''
    },
  },
  setup(props) {
    const email = ref(props.userEmail);
    const emailConfig = reactive({
      email: {
        label: props.texts.label,
        touched: touchedState(email.value),
        placeholder: props.texts.emailplaceholdertext,
        value: () => email.value,
        validation: computed(() => {
          if (!emailConfig.email.touched) return { valid: true, error: "" };
          const result = validateEmail(email.value, props.texts.label);
          return {
            valid: result.isValid,
            error: result.isValid ? "" : result.errorMessage || props.texts.emailformatvalidationmessage,
          };
        })
      }
    });

    return {
      email,
      emailConfig,
      markFieldAsTouched
    }
  }
}
